(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["padel-hook-picker"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sid = '{{ section.id }}';
  var picker   = document.getElementById('padel-picker-' + sid);
  var hooksRow = document.getElementById('pp-hooks-' + sid);
  var hint     = document.getElementById('pp-hint-' + sid);
  var summaryText = document.getElementById('pp-summary-text-' + sid);
  var COLOURS = {
    black:  { hex: '#1a1a1a', label: 'Black'  },
    white:  { hex: '#f2f2f2', label: 'White'  },
    red:    { hex: '#dc2626', label: 'Red'    },
    blue:   { hex: '#2563eb', label: 'Blue'   },
    orange: { hex: '#f97316', label: 'Orange' },
    yellow: { hex: '#fbbf24', label: 'Yellow' }
  };
  var state = { mode: 'same', hookColors: ['black','black','black','black','black'], selectedHook: -1 };
  var hookWraps = Array.from(hooksRow.querySelectorAll('.pp-hook-wrap'));
  var swatchBtns = Array.from(picker.querySelectorAll('.pp-swatch'));
  var modeBtns  = Array.from(picker.querySelectorAll('.pp-mode-btn'));
  function applyColorToHook(idx, colorKey) {
    state.hookColors[idx] = colorKey;
    var fills = hookWraps[idx].querySelectorAll('.hook-fill');
    fills.forEach(function(el) { el.style.fill = COLOURS[colorKey].hex; });
    hookWraps[idx].classList.remove('pp-hook-wrap--bouncing');
    void hookWraps[idx].offsetWidth;
    hookWraps[idx].classList.add('pp-hook-wrap--bouncing');
    setTimeout(function() { hookWraps[idx].classList.remove('pp-hook-wrap--bouncing'); }, 400);
  }
  function updateSummary() {
    var colors = state.hookColors;
    var allSame = colors.every(function(c) { return c === colors[0]; });
    if (allSame) {
      summaryText.textContent = '5 × ' + COLOURS[colors[0]].label;
    } else {
      summaryText.textContent = colors.map(function(c, i) { return 'Hook ' + (i+1) + ': ' + COLOURS[c].label; }).join('  ·  ');
    }
  }
  function setActiveSwatch(colorKey) {
    swatchBtns.forEach(function(btn) { btn.classList.toggle('pp-swatch--active', btn.dataset.color === colorKey); });
  }
  function setMode(mode) {
    state.mode = mode;
    state.selectedHook = -1;
    modeBtns.forEach(function(btn) {
      var active = btn.dataset.mode === mode;
      btn.classList.toggle('pp-mode-btn--active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    hookWraps.forEach(function(wrap) {
      wrap.classList.toggle('pp-hook-wrap--selectable', mode === 'mix');
      wrap.classList.remove('pp-hook-wrap--selected');
    });
    if (mode === 'same') {
      hint.textContent = 'Click a colour below to apply it to all hooks';
      setActiveSwatch(state.hookColors[0]);
    } else {
      hint.textContent = 'Click a hook above, then choose its colour';
      swatchBtns.forEach(function(btn) { btn.classList.remove('pp-swatch--active'); });
    }
  }
  hookWraps.forEach(function(wrap, idx) {
    wrap.addEventListener('click', function() {
      if (state.mode !== 'mix') return;
      state.selectedHook = idx;
      hookWraps.forEach(function(w, i) { w.classList.toggle('pp-hook-wrap--selected', i === idx); });
      hint.textContent = 'Now choose a colour for Hook ' + (idx+1);
      setActiveSwatch(state.hookColors[idx]);
    });
    wrap.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); wrap.click(); }
    });
  });
  swatchBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var colorKey = btn.dataset.color;
      if (state.mode === 'same') {
        state.hookColors.forEach(function(_, i) { applyColorToHook(i, colorKey); });
        setActiveSwatch(colorKey);
      } else {
        if (state.selectedHook === -1) {
          state.hookColors.forEach(function(_, i) { applyColorToHook(i, colorKey); });
          setActiveSwatch(colorKey);
        } else {
          applyColorToHook(state.selectedHook, colorKey);
          setActiveSwatch(colorKey);
        }
      }
      updateSummary();
    });
  });
  modeBtns.forEach(function(btn) {
    btn.addEventListener('click', function() { setMode(btn.dataset.mode); });
  });
  (function init() {
    var variantPicker = document.querySelector('[name="Color"], [name="color"], [name="Colour"], [name="colour"]');
    var initColor = 'black';
    if (variantPicker) {
      var val = (variantPicker.value || '').toLowerCase();
      if (COLOURS[val]) initColor = val;
    }
    state.hookColors = [initColor, initColor, initColor, initColor, initColor];
    hookWraps.forEach(function(_, i) { applyColorToHook(i, initColor); });
    setActiveSwatch(initColor);
    updateSummary();
    document.addEventListener('change', function(e) {
      if (!e.target) return;
      var name = (e.target.name || '').toLowerCase();
      if (name === 'color' || name === 'colour') {
        var newColor = e.target.value.toLowerCase();
        if (COLOURS[newColor] && state.mode === 'same') {
          state.hookColors = [newColor, newColor, newColor, newColor, newColor];
          hookWraps.forEach(function(_, i) { applyColorToHook(i, newColor); });
          setActiveSwatch(newColor);
          updateSummary();
        }
      }
    });
  })();
})();

  } catch(e) { console.error(e); }
})();
})();
